"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
require("../fonts/fonts.css");
var neutralTheme_1 = require("./neutralTheme");
var csTheme_1 = require("./csTheme");
var bekoTheme_1 = require("./bekoTheme");
exports.ThemeProvider = function (_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? 'bekoLight' : _b, _c = _a.language, language = _c === void 0 ? 'de' : _c;
    var appliedTheme = csTheme_1.csTheme({ theme: theme, language: language });
    if (theme === 'neutralLight') {
        appliedTheme = neutralTheme_1.neutralTheme({ theme: theme, language: language });
    }
    else if (theme === 'bekoLight') {
        appliedTheme = bekoTheme_1.bekoTheme({ theme: theme, language: language });
    }
    return (react_1.default.createElement(core_1.MuiThemeProvider, { theme: appliedTheme },
        react_1.default.createElement(core_1.CssBaseline, null),
        children));
};
exports.default = exports.ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map